import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APP_ROUTING_NAMES } from '../app.routes.names';
import { FEATURE_NAMES } from '../model/constants/features';
import { IFeatureToggle } from '../model/service/ifeature-toggle';
import { FeatureToggleService } from '../service/feature-toggle/feature-toggle.service';

@Injectable({
  providedIn: 'root',
})
export class ViewApplicationGuard  {

  constructor(private router: Router, private service: FeatureToggleService) { }

  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.service.getFeatureToggle(FEATURE_NAMES.VIEW_LLEG_APPLICATION)
      .pipe(
        map((value: IFeatureToggle) => {
          if (!value.enabled) {
            this.router.navigate([APP_ROUTING_NAMES.NOT_FOUND]);
          }
          return value.enabled;
        }),
        catchError(() => {
          this.router.navigate([APP_ROUTING_NAMES.NOT_FOUND]);
          return of(false);
        }),
      );
  }
}
